import React from 'react'
import InfiniteSelect from '../../../InfiniteSelect'
import ApiService from '../../../../services/ApiService'
import PantoneSelect, { PantoneValue } from '../../../PantoneSelect'
import { InputDiv, Label } from '../../../styles/modal-style'

interface ColorFieldProps {
  isFashionTenant: boolean
  colorError: boolean
  pantoneError: boolean
  originalColorName: string | null
  selectedColor: { id: number | string; name: string; pantone?: any } | null
  pendingColorPantone: any
  setSelectedColor: (value: { id: number | string; name: string; pantone?: any } | null) => void
  setPendingColorPantone: (value: any) => void
  setColorError: (v: boolean) => void
  setPantoneError: (v: boolean) => void
}

const ColorField: React.FC<ColorFieldProps> = ({
  isFashionTenant,
  colorError,
  pantoneError,
  originalColorName,
  selectedColor,
  pendingColorPantone,
  setSelectedColor,
  setPendingColorPantone,
  setColorError,
  setPantoneError,
}) => {
  if (!isFashionTenant) return null

  return (
    <>
      <InputDiv>
        <Label style={colorError ? { color: 'red' } : {}}>
          Cor
          <span style={{ color: 'red', marginLeft: 2 }}>*</span>
          {colorError && (
            <span style={{ fontSize: '12px', color: 'red', marginLeft: 6, fontWeight: 400 }}>
              A cor é obrigatória!
            </span>
          )}
          {!colorError && originalColorName && (
            <span style={{ fontSize: '12px', color: '#6B7280', marginLeft: 6, fontWeight: 400 }}>
              (original: <strong>{originalColorName}</strong>)
            </span>
          )}
        </Label>
        <div style={colorError ? { border: '1px solid red', borderRadius: 6, overflow: 'hidden' } : {}}>
          <InfiniteSelect
            mode="crud"
            value={selectedColor}
            onSelect={(option) => {
              setSelectedColor(option)
              setColorError(false)
              setPendingColorPantone(option?.pantone ?? null)
            }}
            fetchFunction={async (limit, offset, search?) => {
              const response = await ApiService.resources.getColors()
              const items = response.data || []
              const filtered = search
                ? items.filter((c: any) => c.name?.toLowerCase().includes(search.toLowerCase()))
                : items
              return filtered.map((c: any) => ({ id: c.id, name: c.name, pantone: c.pantone ?? null }))
            }}
            onItemCreate={async (name: string) => {
              const tempItem = { id: `tmp-${Date.now() as any}`, name: name.trim(), pantone: null }
              setSelectedColor(tempItem)
              setPendingColorPantone(null)
              return tempItem as any
            }}
            onItemDelete={async (colorId: any) => {
              const isTemp = typeof colorId === 'string' && String(colorId).startsWith('tmp-')
              if (!isTemp) {
                await ApiService.resources.deleteColor(colorId)
              }
            }}
            placeholder="Buscar ou criar cor"
            allowCreate={true}
            allowDelete={true}
            showCreateOnlyIfNotExists={true}
            minCreateLength={2}
          />
        </div>
      </InputDiv>

      {selectedColor && !selectedColor.pantone?.code && (
        <InputDiv style={{ marginTop: 8, padding: 10, backgroundColor: '#f0f7ff', borderRadius: 8, border: '1px solid #bfdbfe' }}>
          <Label style={{ fontSize: 11, color: pantoneError ? '#e53e3e' : '#374151', display: 'block', marginBottom: 4, fontWeight: 500 }}>
            Pantone para <strong>{selectedColor.name}</strong> <span style={{ color: '#e53e3e' }}>*</span>
          </Label>
          <PantoneSelect
            value={pendingColorPantone}
            onSelect={(p) => {
              if (p) {
                setSelectedColor({ ...selectedColor, pantone: p })
                setPendingColorPantone(p)
                setPantoneError(false)
              } else {
                setSelectedColor({ ...selectedColor, pantone: null })
                setPendingColorPantone(null)
              }
            }}
            placeholder="Buscar Pantone (mín. 3 letras)"
          />
        </InputDiv>
      )}

      {selectedColor?.pantone?.code && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4, fontSize: 12, color: '#555' }}>
          {selectedColor.pantone.hex && (
            <span style={{
              display: 'inline-block', width: 12, height: 12, borderRadius: 3,
              backgroundColor: selectedColor.pantone.hex.startsWith('#') ? selectedColor.pantone.hex : `#${selectedColor.pantone.hex}`,
              border: '1px solid rgba(0,0,0,0.15)',
            }} />
          )}
          <span>Pantone: <strong>{selectedColor.pantone.code}</strong> - {selectedColor.pantone.name}</span>
        </div>
      )}
    </>
  )
}

export default ColorField
